export default __webpack_public_path__ + "static/media/Section3_Image.86cf877f.png";